import React from 'react'
import PropTypes from 'prop-types'

import { withTranslation } from '../../translations'

import './language_switcher.css'

export const LanguageSwitcher = ({
  currentLanguage,
  languages,
  selectedLanguage,
  setLanguage,
  t,
}) => (
  <div className="language-switcher print-none">
    <button
      className="language-switcher-tab"
      type="button"
      aria-label={t('language.selector.help')}
    >
      <span className="language-switcher-flag">{selectedLanguage.flag}</span>
      <span>{selectedLanguage.shortCode}</span>
    </button>
    <div className="language-switcher-panel">
      <label className="language-switcher-label" htmlFor="language-switcher">
        {t('language.selector.label')}
      </label>
      <select
        id="language-switcher"
        className="language-switcher-select"
        value={currentLanguage}
        onChange={(event) => setLanguage(event.target.value)}
      >
        {languages.map((language) => (
          <option key={language.code} value={language.code}>
            {language.flag} {language.name}
          </option>
        ))}
      </select>
    </div>
  </div>
)

LanguageSwitcher.propTypes = {
  currentLanguage: PropTypes.string.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      flag: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      shortCode: PropTypes.string.isRequired,
    })
  ).isRequired,
  selectedLanguage: PropTypes.shape({
    flag: PropTypes.string.isRequired,
    shortCode: PropTypes.string.isRequired,
  }).isRequired,
  setLanguage: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
}

export default withTranslation(LanguageSwitcher)
